<template>
  <div class="loan-beacon-widget-page">
    <LoanBeaconWidget />
  </div>
</template>

<script>
import LoanBeaconWidget from '@/components/widget/loanBeacon/index.vue';

export default {
  name: 'LoanBeaconWidgetPage',
  components: {
    LoanBeaconWidget,
  },
  data() {
    return {
      businessId: 1234,
      active: true,
      isOwner: true,
    };
  },
};
</script>


<style scoped lang="scss">
.loan-beacon-widget-page {
  @include stack-space($space-large);
  @include inset-space($space-large);
  background-color: $color-background-primary;
}
</style>
